import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Jak nawigować w Bibliodesku - Książki posiadane oraz pożyczone\ndescription: Bibliodesk umożliwia śledzenie stanu książek.\n---\n\nBibliodesk umożliwia sprawdzanie stanu posiadania danego egzemplarza.\n\n___\n\n## Książki posiadane\n\n__Posiadane__ to lista wszystkich książek, których obecnie jesteśmy właścicielami. Książki mają status dostępne czyli _są widoczne na publicznym profilu dostępnym dla każdego niezarejestrowanego użytkownika_. Możemy w każdej chwili zmienić stan każdej książki na __niedostepny__.\n\nTo przydatna funkcja dla książek, które sprzedaliśmy, nie stoją już na naszych półkach lub takich, których nie chcemy pokazywać innym na publicznym profilu.\n\nJeśli książkę komuś oddajemy lub sprzedajemy, zacięćmy ich do założenia konta na YouTalky i zeskanowania z niej kodu.\n\n{% callout type=\"note\" title=\"Czy wiesz, że...\" %}\n\nkażda książka, której jesteśmy właścicielami, po zeskanowaniu etykiety QR przez innego użytkownika zniknie z naszego Bibliodesku całkowicie a przyszły właściciel będzie miał wgląd do listy poprzednich właścicieli książki?\n\n{% /callout %}\n\n![Kody do katalogowania](/imgs/docs/bibliodesk/copies/bibliodesk-ksiazki-oddane-01.png)\n\n\n## Książki niedostępne\n\nLista wszystkich książek, których stan zmieniliśmy na niedostępne. Książki wyświetlane tutaj będą widoczne tylko dla nas, nie będą widoczne na naszym publicznym profilu.\n\n\n![Kody do katalogowania](/imgs/docs/bibliodesk/copies/bibliodesk-ksiazki-oddane-02.png)\n";
const filepath = "/docs/bibliodesk-egzemplarze-ksiazek-uzytkownika.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
